export default "__VITE_PUBLIC_ASSET__a5e915a1__"